<template>
    <div>
      <!-- modal -->
      <b-modal id="authControlFormModal" ref="authControlFormModal" size="md" no-close-on-backdrop :title=" $t('authControl.info')" 
        hide-footer>
        <validation-observer ref="simpleRules">
            <b-form class="mb-1">
                <label for="auth-control-verification-code-input">{{ $t('authControl.verification_code') }}</label>
                <b-col>
                    <b-input-group>
                        <validation-provider #default="{ errors }" :name=" $t('authControl.verification_code')" rules="required">
                          <b-form-input id="auth-control-verification-code-input" size="sm" v-model="verificationCode" @keypress="onKeyPress" @input="verificationCodeApplied" maxlength="6" :state="errors.length > 0 ? false:null"/>
                        </validation-provider>
                    <b-input-group-append>
                      <b-button variant="outline-secondary" size="sm" disabled>
                        {{ formattedCountdown }}
                      </b-button>
                    </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-form>
        </validation-observer>
      </b-modal>
    </div>
  </template>
  <script>
  export default {
    watch: {
      verificationCode(val){
        if(val != ''){
          this.buttonDisabled = true
        } this.buttonDisabled = false
      }
    },
    data() {
      return {
        username: '',
        verificationCode: '',
        countdown: 180,
        timer: null,
        buttonDisabled: false
      }
    },
    computed: {
      formattedCountdown() {
        const minutes = String(Math.floor(this.countdown / 60)).padStart(2, '0') //Dakika hesabı
        const seconds = String(this.countdown % 60).padStart(2, '0') //Saniye hesabı
        return `${minutes}:${seconds}` //Dakika-Saniye parametresi
      } 
    },
    methods: {
      onKeyPress(event) {
        const char = String.fromCharCode(event.which);
        if (!/[0-9]/.test(char)) {
          event.preventDefault();  // Harf ise hiç yazmasına izin verme
        }
      },
      showInfo(username) {
        this.username = username
        this.countdown = 180
        this.startTimer() //Timer yukarıdaki ifadede countdown adıyla 300 saniyeye ayarlandı. Burada da timer'ı başlatıyoruz
        this.$refs['authControlFormModal'].show()
      },
      startTimer() {
        if (this.timer) clearInterval(this.timer) //Timer temizleme
        this.timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown-- //Countdown parametresinin azalarak devam etmesi sağlandı
          } else {
            clearInterval(this.timer)
            this.timer = null
            this.closeModalByTimeout() //Modalı kapat
          }
        }, 1000) //Hata olmaması için delay hesaba katıldı.
      },
      closeModalByTimeout() { 
        this.$bvModal.hide('authControlFormModal')
        this.$WarningAlert(this.$t('authControl.timeout'))
      },
      verificationCodeApplied() {
          const cleaned = this.verificationCode.replace(/\D/g, '').slice(0, 6);
          if (this.verificationCode !== cleaned) {
            this.verificationCode = cleaned; // Temizle
          }

          if(this.verificationCode.length == 6){
            let loader = this.$loading.show()
            const data = { username: this.username, twoFactorCodeEnteredByUser: this.verificationCode}
            const controller = { name: 'Employee', actionName: 'CheckEmployee2FACode'}
            const payload = { data, controller }
            this.$refs.simpleRules.validate().then(success => {
              if (success) {
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                  if (response.data.resultMessage == "TwoFactorAuthenticationSuccess") {
                    localStorage.setItem('accessToken', response.data.token)
                    this.$store.commit('moduleAuth/SET_BEARER', response.data.token)
                    clearInterval(this.timer) //Timer'ı temizle
                    this.timer = null
                    this.$bvModal.hide('authControlFormModal')
                    this.$VerificationCodeConfirm()
                    this.$router.push({ name: 'Home' }).catch(error => {
                      if (
                        error.name !== 'NavigationDuplicated' &&
                        !error.message.includes('Avoided redundant navigation to current location')
                        ) {
                          console.log(error)
                        }
                      })
                    } else {
                        this.$VerificationCodeNotConfirm()
                    }
                  })
                }
                loader.hide()
              })
          }
        }
      },
    beforeDestroy() {
      if (this.timer) clearInterval(this.timer)
    }
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  #auth-control-verification-code-input {
    flex: 1 1 auto !important;
    min-width: 360px;
    max-width: 100%;
  }

  .b-input-group {
    align-items: flex-start; 
  }
  
  .b-input-group .form-control {
    margin-bottom: 0 !important;
  }
  
  .validation-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .validation-wrapper small {
    margin-top: 0.25rem;
  }
  </style>
  